export default __webpack_public_path__ + "static/media/chicken-asparagus.d4482325.jpeg";